module.exports = __webpack_public_path__ + "static/media/korndorf-and-ledenyov.195946e3.jpg";